export default "__VITE_ASSET__CCkN$w1z__"